import type { UnionOfPropertyTypes } from '@backmarket/utils/object/UnionOfPropertyTypes'
import type { Option } from '@ds/components/InputSelect'

import type { BuyBackQuote, BuyBackQuoteListing } from '~/api/quotes/types'

export interface Pagination {
  pageSize: number
  currentPage: number
  count: number
  previous: string | null
  next: string | null
}

export interface WishListData {
  availableMarkets: Array<Option>
  quotes: Array<BuyBackQuote> | null
  marketCode: string
  filters: object
  filtersLoadingButton: string
  isLoading: boolean
  isModalActionLoading: boolean
}

export const GROUP_IDS = {
  WITHOUT_BACKBOX: 'withoutBackbox',
  WITH_BACKBOX: 'withBackbox',
  OFFLINE: 'offline',
} as const

export type GroupIds = UnionOfPropertyTypes<typeof GROUP_IDS>

export interface BuyBackListingsGroup {
  id: GroupIds
  title: string
  listings: Array<BuyBackQuoteListing>
}

export const GRADES_TRANSLATIONS_KEYS = {
  NOT_FUNCTIONAL_CRACKED: 'gradeBrokenCraks',
  NOT_FUNCTIONAL_USED: 'gradeBrokenScratches',
  FUNCTIONAL_CRACKED: 'gradeCracked',
  FUNCTIONAL_USED: 'gradeUsed',
  FUNCTIONAL_GOOD: 'gradeGood',
  FUNCTIONAL_FLAWLESS: 'gradeFlawless',
}
